<template>
  <div class="box12">
    <pageTitle title="高质量课程" text />

    <commonFreeVideo class="box" :videoList="videoList" pageName="JavaEE-就业课" />

    <!-- <div class="btn" @click="toLink('https://m.boxuegu.com/')"> -->
    <div class="btn" @click="zixun('获取更多')">
      获取更多
      <span>></span>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commonFreeVideo from "../common/common-free-video.vue";
export default {
  components: {
    pageTitle,
    commonFreeVideo,
  },
  data() {
    return {
      videoList: [
        {lessonName:"ZooKeeper+Dubbo分布式架构基础教程",
          url: "https://www.boxuegu.com/freecourse/detail-1576.html",
          img: require("../../../assets/coursePage/java/box13/01.png"),
        },
        {lessonName:"MySQL数据库高级应用与性能优化",
          url: "https://www.boxuegu.com/freecourse/detail-1574.html",
          img: require("../../../assets/coursePage/java/box13/02.png"),
        },
        {lessonName:"分布式事务解决方案",
          url: "https://www.boxuegu.com/freecourse/detail-1573.html",
          img: require("../../../assets/coursePage/java/box13/03.png"),
        },
        {lessonName:"SpringCloud微服务架构技术应用",
          url: "https://www.boxuegu.com/freecourse/detail-1572.html",
          img: require("../../../assets/coursePage/java/box13/04.png"),
        },
        {lessonName:"快乐的Java网络编程",
          url: "https://www.boxuegu.com/freecourse/detail-1521.html",
          img: require("../../../assets/coursePage/java/box13/05.png"),
        },
        {lessonName:"1小时掌握Redis哨兵模式",
          url: "https://www.boxuegu.com/freecourse/detail-1520.html",
          img: require("../../../assets/coursePage/java/box13/06.png"),
        },
        {lessonName:"Java“方式”学的好程序代码复用高",
          url: "https://www.boxuegu.com/freecourse/detail-1519.html",
          img: require("../../../assets/coursePage/java/box13/07.png"),
        },
        {lessonName:"轻松学好多线程JAVA并发不头疼",
          url: "https://www.boxuegu.com/freecourse/detail-1518.html",
          img: require("../../../assets/coursePage/java/box13/08.png"),
        },
      ],
    };
  },
  methods: {
    zixun(name) {
        this.mai("JavaEE-就业课","获取更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box12 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/java/box13/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .box {
    margin-top: 48px;
  }
  .btn {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #165dff;
  }
}
</style>
